export default __webpack_public_path__ + "static/media/checkbox-enabled-unchecked.8975b501.svg";